import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/268V-logo.png'
import _imports_1 from '../../../assets/image/icon-right.png'
import _imports_2 from '../../../assets/image/inspector_icon.png'
import _imports_3 from '../../../assets/image/service_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-07aaee40")

_pushScopeId("data-v-07aaee40")
const _hoisted_1 = { class: "ui__serviceInfo_main" }
const _hoisted_2 = { class: "ui__serviceInfo_body" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 本检测服务由")
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "logoIcon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提供")
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "rightIcon",
  src: _imports_1
}, null, -1)
const _hoisted_7 = { class: "ui__serviceInfo_content" }
const _hoisted_8 = { class: "ui__serviceInfo_inspector" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "ui__serviceInfo_inspector_img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    style: {"pointer-events":"none"}
  })
], -1)
const _hoisted_10 = { class: "ui__serviceInfo_modal" }
const _hoisted_11 = { class: "ui__serviceInfo_modal_name" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "ui__serviceInfo_modal_rank" }, "268V检测工程师", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "ui__serviceInfo_button" }, [
  /*#__PURE__*/_createVNode("a", { href: "tel:400-808-3718" }, "联系客服")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "bottom-line" }, null, -1)
const _hoisted_15 = { class: "ui__serviceInfo_explain" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icon_service"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 提供90天内错检回购服务 ")
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon_right"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 具体服务保障说明可见")
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "《保障服务说明》", -1)
const _hoisted_21 = { class: "ui__comTitle_model" }
const _hoisted_22 = { class: "ui__comTitle_model_title" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 90天内错检回购服务 ")
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_cnt" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, " 通过268V实车检测的车辆，检测保障激活后，自承保激活日起90天内，若您发现被检测车辆为重大事故、火烧、泡水车而检报告未准确反映的，268V负责对该车辆进行差价赔付或按交易价回购。 "),
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, "检报告激活方式"),
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, [
    /*#__PURE__*/_createTextVNode(" ① 微信搜索“268V车况检测专家”小程序；"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" ② 点击【激活保障】，进入激活页面"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" ③ 填写成交信息及上传交易凭证，即可激活90天回购保障说明：请在车辆完成交易及过户后再激活保障。 ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ui__serviceInfo_title",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goIntroduce && _ctx.goIntroduce(...args)))
      }, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.state.Inspector), 1),
            _hoisted_12
          ]),
          _hoisted_13
        ]),
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _createVNode("div", {
            class: "ui__serviceInfo_explain_top",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showModel && _ctx.showModel(...args)))
          }, [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18
          ]),
          _createVNode("div", {
            class: "ui__serviceInfo_explain_bottom",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
          }, [
            _hoisted_19,
            _hoisted_20
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode("img", {
          src: require('../../../assets/image/close-icon.png'),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      _hoisted_24
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ])
  ]))
})